import { FirebaseResumeRepository } from "../../core/repositories/resume/FirebaseResumeRepository";
import { IResumeRepository } from "../../core/repositories/resume/IResumeRepository";
import Cubit from "../../core/utils/cubit";
import { IProcessingService, ProcessingService } from "../processing-service/ProcessingService";
import { ResumeState } from "./ResumeState";

export abstract class IResumeBloc extends Cubit<ResumeState> {
    abstract getLatestResume: () => Promise<ResumeState>;
    abstract getResumeById: (id: string) => Promise<ResumeState>;
}

export class ResumeBloc extends IResumeBloc {
    private resumeRepository:IResumeRepository = new FirebaseResumeRepository();
    private processingService:IProcessingService = ProcessingService.getInstance();
    constructor() {
        super({state: "LOADING"});
        this.getLatestResume();
    }
    getLatestResume: () => Promise<ResumeState> = async () => {
        try {
            this.emit({state: "LOADING"});
            this.processingService.startProcessing();
            let resume = await this.resumeRepository.getResume();
            this.emit({state: "LOADED", data: resume});
        } catch (error) {
            this.emit({state: "ERROR", error});
        } finally {
            this.processingService.stopProcessing();
        }
        return this.state;
    }

    getResumeById: (id: string) => Promise<ResumeState> = async (id: string) => {
        try {
            this.emit({state: "LOADING"});
            this.processingService.startProcessing();
            let resume = await this.resumeRepository.getResumeById(id);
            this.emit({state: "LOADED", data: resume});
        } catch (error) {
            this.emit({state: "ERROR", error});
        } finally {
            this.processingService.stopProcessing();
        }
        return this.state;
    }

}